import { defineComponent, ref } from "vue";
import AssetUploader from "@com/components/asset-uploader/index.vue";
import AssetDialogTrigger from "@com/components/asset-dialog/asset-dialog-trigger.vue";
import { createStorageTipsComponent } from "@com/components/storage-tips/index";
// @ts-ignore
var StorageTips = createStorageTipsComponent(function() {
    return false;
});
export default defineComponent({
    components: {
        AssetUploader: AssetUploader,
        AssetDialogTrigger: AssetDialogTrigger,
        StorageTips: StorageTips
    },
    props: {
        accepts: Array,
        maxSize: Number,
        activeRules: Array,
        showTrigger: Boolean,
        isStorageFull: Boolean,
        type: String,
        skeletonType: Number
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var loading = ref(false);
        var uploadComplete = function() {
            emit("uploadComplete");
        };
        var handleClick = function() {
            emit("dialogTrigger");
        };
        return {
            loading: loading,
            uploadComplete: uploadComplete,
            handleClick: handleClick
        };
    }
});
